<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="`performance-evaluations/evaluator/storeDocument`"
      >
        <div class="my-2">
          <div class="row">
            <div class="col-12" v-if="false">
              <legend>
                <small>
                  <p class="text-primary">Historial de la documentación de evaluación</p>
                </small>
              </legend>
              <table class="table table-sm table-striped">
                <thead>
                  <tr>
                    <th scope="col" class="align-middle">Nombre</th>
                    <th scope="col" style="width: 10%" class="align-middle"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, key) in inputs.evaluation_team_performance_historical" :key="key"> 
                    <td class="align-middle">{{value.file_name}} {{key+1}}</td>
                    <td class="align-middle text-center">
                      <button
                        type="submit"
                        class="btn btn-success"
                        @click.prevent="
                          openTabHist(value.path)
                        "
                      >
                        <app-icon name="file" />
                        {{ $t("view") }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>

            </div>
            <div v-if="inputs.evaluation_team_performance_historical && inputs.evaluation_team_performance_historical.length > 0 && inputs.observations" class="col-12">
              <label class="text-primary">Observaciones del rechazo de la evaluación de desempeño</label>
              <app-input
                type="textarea"
                v-model="inputs.observations"
                :disabled="true"
              />
            </div>
            <div class="col-12 mt-3">
              <div class="form-group">
                  <label class="text-primary">Evaluación</label>
                <app-input
                  type="file"
                  v-model="inputs.file_1"
                  :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
                  :required="true"
                  v-if="!inputs.evaluation_team_performance"
                />
                <div>
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTab(inputs, 'evaluation_team_performance')"
                    v-if="inputs.evaluation_team_performance"
                  >
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>

                  <button
                    type="submit"
                    class="btn btn-danger"
                    @click.prevent="inputs.evaluation_team_performance = null"
                    v-if="inputs.evaluation_team_performance"
                  >
                    <app-icon name="trash-2" />
                    {{ $t("delete") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import CoreLibrary from "@/core/helpers/CoreLibrary.js";

export default {
  name: "ModalDocument",
  extends: CoreLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    modalTitle: String,
    idEvaluator: Number,
  },
  data() {
    return {
      preloader: false,
      loaded: false,
      inputs: {
        is_observation: 0,
      },
      modalId: "modal-document-edit",
      confirm: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
    };
  },
  computed: {
    title() {
      return this.modalTitle;
    },
  },
  created() {
    this.infoEvaluator();
  },
  methods: {
    submit() {
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.save(formData);
    },
    afterSuccess(response) {
      this.$toastr.s(this.$t("updated_success"));
    },
    afterError(response) {
      this.$toastr.e(response.data.message);
    },
    infoEvaluator() {
      this.preloader = true;
      let url = `/performance-evaluations/evaluator/showEvaluator/${this.idEvaluator}`;
      this.axiosGet(url).then((response) => {
        this.inputs = response.data;
      }).catch(({ error }) => {
        console.log(error);
      })
      .finally(() => {
        this.preloader = false;
      });
    },
    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
    openTabHist(file) {
      const w = window.open(file, "_blank");
      w.focus();
    },
  },

};
</script>
<style>

</style>
